// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__OsvaQ","alertIcon":"ConfirmModal_alertIcon__jlCLR"};